// PERF: the "Latest" per-ticker flow views — ticker_option_flow_all_sides,
// free_ticker_option_flow, full_feed_equity_print_flow, equity_print_flow_full — each filter
// internally on `date >= (SELECT max(date) …) - interval '28 days'`. That scalar subquery is
// opaque to the Postgres planner, so a query with a large LIMIT (5k–10k) plus an ORDER BY on
// createdAt/timestamp mis-estimates selectivity and walks the ticker's ENTIRE history instead of
// the date index — 30s+ responses, edge 504s, and DB load spikes.
//
// Passing a *literal* lower date bound (`date: { _gte: <sinceDate> }`) gives the planner a
// concrete constant so it uses the date index (measured ~30s -> ~0.1s on the dark-pool view).
// 35 days is a safe superset of the view's 28-day window, so the returned rows are identical —
// the view still narrows to 28 days. Kept intentionally in sync with the server resolvers in
// services/server/graphql/queries/* which apply the same bound.
export const TICKER_FLOW_WINDOW_DAYS = 35;

/**
 * Rolling literal lower date bound (`YYYY-MM-DD`, UTC) for the per-ticker "Latest" flow queries.
 * The value is stable within a calendar day, so it is safe to call inline on every render — the
 * variables stay value-equal and will not trigger Apollo refetch loops.
 */
export function getTickerFlowSinceDate(): string {
  return new Date(Date.now() - TICKER_FLOW_WINDOW_DAYS * 24 * 60 * 60 * 1000)
    .toISOString()
    .slice(0, 10);
}
